<section class="container-capped" *ngIf="current">
	<form class="form-container form-horizontal" (submit)="profile.valid && update()" #profile="ngForm" autocomplete="on">
		<h2 class="mb-1">شماره کاربری: {{current.Username}}</h2>
		<div class="form-group">
			<input type="text" class="form-control" autocomplete="name" name="name" required placeholder="نام و نام خانوادگی"
				[(ngModel)]="current.Name">
		</div>
		<ng-container *ngIf="(!section||section=='Employer')&&current.Employer?.Disabled==false">

			<h2 class="f-blue mt-4">اطلاعات کارفرما</h2>
			<div class="form-group">
				<input type="text" class="form-control" autocomplete="organization-title" name="employer-company"
					placeholder="نام شرکت" [(ngModel)]="current.Employer.Company" required>
			</div>
			<div class="form-group">
				<input type="text" dir="ltr" class="form-control" name="employer-email" placeholder="ایمیل شرکت"
					[(ngModel)]="current.Employer.Email">
			</div>
			<div class="form-group">
				<input type="text" class="form-control" autocomplete="tel" name="employer-phone" placeholder="تلفن شرکت"
					[(ngModel)]="current.Employer.Phone">
			</div>
			<div class="form-group">
				<app-location name="employer-location" [(ngModel)]="current.Employer"></app-location>
			</div>
			<div class="form-group">
				<input type="text" class="form-control" autocomplete="street-address" name="employer-address"
					placeholder="آدرس شرکت" [(ngModel)]="current.Employer.Address">
			</div>
		</ng-container>
		<ng-container *ngIf="(!section||section=='Agent')&&current.Agent?.Disabled==false">

			<h2 class="f-blue mt-4">اطلاعات کاریابی</h2>
			<div class="form-group">
				<input type="text" class="form-control" autocomplete="organization-title" name="agent-company"
					placeholder="نام کاریابی" [(ngModel)]="current.Agent.Company" required>
			</div>
			<div class="form-group">
				<input type="email" dir="ltr" class="form-control" name="agent-email" placeholder="ایمیل کاریابی"
					[(ngModel)]="current.Agent.Email">
			</div>
			<div class="form-group">
				<input type="tel" dir="ltr" class="form-control" autocomplete="tel" name="agent-phone"
					placeholder="تلفن کاریابی" [(ngModel)]="current.Agent.Phone">
			</div>
			<div class="form-group">
				<input type="url" dir="ltr" class="form-control" autocomplete="url" name="agent-website" placeholder="وبسابت"
					[(ngModel)]="current.Agent.Website">
			</div>
			<div class="form-group">
				<input type="url" dir="ltr" class="form-control" autocomplete="url" name="agent-logo" placeholder="لوگو"
					[(ngModel)]="current.Agent.Logo">
				<img *ngIf="current.Agent.Logo" [src]="current.Agent.Logo" style="max-height:50px;max-width: 50px;" />
			</div>
			<div class="form-group">
				<app-location name="agent-location" [(ngModel)]="current.Agent"></app-location>
			</div>
			<div class="form-group">
				<input type="text" class="form-control" autocomplete="street-address" name="agent-address"
					placeholder="آدرس کاریابی" [(ngModel)]="current.Agent.Address">
			</div>
		</ng-container>
		<div class="cross-validation-error-message alert alert-danger"
			*ngIf="profile.invalid && (profile.touched || profile.dirty)">
			لطفا در وارد کردن فیلدهای مورد نظر دقت فرمایید
			<!-- {{form.controls.description.errors}} -->
		</div>
		<div class="text-left mb-4">
			<button class="btn btn-primary" type="submit" [disabled]="profile.invalid">ذخیره</button>
			<div class="btn btn-danger" (click)="deleteModal.open()">حذف حساب کاربری</div>
		</div>
	</form>
</section>

<!-- Delete Account Modal -->
<ngx-smart-modal #deleteModal identifier="deleteModal">
	<div class="container-capped py-3">
		<p>
			<span class="f-red">حذف حساب کاربری</span>
			<br />
			دقت بفرمایید که در صورت حذف اطلاعات، کلیه‌ی داده‌های شما از تمامی پایگاه‌های داده‌ی کارپیشه حذف خواهد شد
			و به هیچ عنوان و تحت هیچ فرایندی قابل بازیابی نیست.<br />
			<span class="f-red">آیا از حذف اطلاعات خود مطمئن هستید؟</span>
		</p>
		<div class="text-center" *ngIf="!codeSent">
			<div class="btn btn-danger" (click)="sendDeleteCode()">حذف حساب کاربری</div>
			<div class="btn btn-primary" (click)="deleteModal.close()">بیخیال! شوخی کردم</div>
		</div>
		<div class="row m-0" *ngIf="codeSent">
			<div>یک کد به شماره همراه شما ارسال شد، لطفا جهت حذف اطلاعات خود کد را وارد نمایید.</div>
			<label class="col-4 d-flex align-items-center">
				<span>کد حذف اکانت</span>
				<input name="delete-code" #deleteCode />
			</label>
			<div class="text-center">
				<div class="btn btn-danger" (click)="deleteAccount(deleteCode.value)">حذف حساب کاربری</div>
				<div class="btn btn-primary" (click)="deleteModal.close()">بیخیال! شوخی کردم</div>
			</div>
		</div>
	</div>
</ngx-smart-modal>